import { MessageAttachment } from '@slack/web-api';
import { httpsCallable, getFunctions } from 'firebase/functions';
import { FirebaseHandlers } from '../core/firebase';

const functions = getFunctions();
const notifyFn: any = httpsCallable(functions, 'slack-notify');

export class SlackService {

  private static WEBHOOK_URL = 'https://hooks.slack.com/services/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';

  /**
   * Sends message to work channel
   */
  public static async notify(message: MessageAttachment): Promise<void> {
    try {
      const response = await fetch(this.WEBHOOK_URL, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin', // include, *same-origin, omit
        headers: {
          'Content-Type': 'application/json'
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        // redirect: 'follow', // manual, *follow, error
        // referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: JSON.stringify(message) // body data type must match "Content-Type" header
      });
      const res = await response.json();
      console.log('Slack res');
      console.log(res);
    } catch (e: any) {
      console.warn('Failed to use fetch, running server call');
      return FirebaseHandlers.run<{ message: MessageAttachment }, void>({ message }, notifyFn);
    }

  }

  // public static notify(message: MessageAttachment): Promise<void> {
  //   return TechPriest.HTTPS_POST<void>(
  //     'https://hooks.slack.com/services/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',
  //     message
  //   );
  // }

}
